import React, { useState } from 'react';
import ContentFilters, { ContentPagination } from '../../components/ContentFilters/ContentFilters';
import useContentList from '../../components/ContentFilters/useContentList';
import { useNavigate } from 'react-router-dom';
import {
    Table,
    Button,
    Card,
    Space,
    message,
    Modal,
    Typography
} from 'antd';
import { EditOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { getParlamentDecisions, deleteParlamentDecision } from '../../services/parlamentDecisionService';

const { Text } = Typography;

const ParlamentDecisionList = () => {
    const { items: data, loading, error, reload: fetchData, filterProps, paginationProps } = useContentList(getParlamentDecisions);
    const [tableLoading, setTableLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const navigate = useNavigate();

    const columns = [
        {
            title: 'Tarih',
            dataIndex: 'date',
            key: 'date',
            render: (date) => dayjs(date).format('DD.MM.YYYY')
        },
        {
            title: 'Karar No',
            dataIndex: 'decisionsNo',
            key: 'decisionsNo'
        },
        {
            title: 'Başlık',
            dataIndex: 'header',
            key: 'header'
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        icon={<EditOutlined />}
                        onClick={() => navigate(`/parlament-decisions/edit/${record.guid}`)}
                    >
                        Düzenle
                    </Button>
                    <Button
                        type="primary"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record)}
                    >
                        Sil
                    </Button>
                </Space>
            )
        }
    ];

    const handleDelete = (record) => {
        setSelectedRecord(record);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        if (!selectedRecord?.guid) return;

        try {
            setTableLoading(true);
            const response = await deleteParlamentDecision(selectedRecord.guid);
            
            if (response.isSuccess) {
                message.success('Meclis kararı başarıyla silindi.');
                setShowDeleteModal(false);
                setSelectedRecord(null);
                await fetchData();
            } else {
                message.error(response.message || 'Silme işlemi başarısız.');
            }
        } catch (error) {
            console.error('Silme hatası:', error);
            message.error('Meclis kararı silinirken bir hata oluştu.');
        } finally {
            setTableLoading(false);
        }
    };

    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
        setSelectedRecord(null);
    };

    return (
        <div className="parlament-decisions-page">
            <div className="arc-page-header">
                <h2>Meclis Kararları</h2>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => navigate('/parlament-decisions/add')}
                >
                    Yeni Meclis Kararı Ekle
                </Button>
            </div>
            <Card>
                <ContentFilters {...filterProps} />
                {error && <div className="alert alert-danger" role="alert">{error}</div>}

            <Table
                columns={columns}
                dataSource={data}
                rowKey="guid"
                loading={loading || tableLoading}
                pagination={false}
            />

            <ContentPagination {...paginationProps} />
        </Card>

        <Modal
            title="Meclis Kararı Sil"
            open={showDeleteModal}
            onOk={handleDeleteConfirm}
            onCancel={handleDeleteCancel}
            okText="Sil"
            cancelText="İptal"
            okButtonProps={{
                danger: true,
                loading: tableLoading
            }}
            maskClosable={false}
            keyboard={false}
            closable={false}
            destroyOnClose
        >
            {selectedRecord && (
                <div>
                    <p>Bu meclis kararını silmek istediğinizden emin misiniz?</p>
                    <p>
                        <Text strong>Başlık:</Text> {selectedRecord.header}<br />
                        <Text strong>Karar No:</Text> {selectedRecord.decisionsNo}
                    </p>
                </div>
            )}
        </Modal>
        </div>
    );
};

export default ParlamentDecisionList;
